import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCardspress,
  addingCardspress,
  addingCardspressFailed,
  CardspressAction,
  CardspressActionTypes,
  editedCardspress,
  editingCardspress,
  editingCardspressFailed,
  foundCardspress,
  loadedCardspress,
  loadingCardspress,
  loadingCardspressFailed,
  removedCardpress,
  removingCardpress,
  removingCardpressFailed,
  searchingCardspress,
  searchingCardspressFailed,
  softRemovedCardspress,
  softRemovingCardspress,
  softRemovingCardspressFailed,
} from '../actions/cardspressActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspressActionTypes.SEARCH_CARDSPRESS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/cardspress/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCardspress(response.data, action.keep)),
        startWith(searchingCardspress()),
        catchError(() => of(searchingCardspressFailed()))
      )
    })
  )

const loadCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CardspressActionTypes.LOAD_CARDSPRESS)),
    switchMap((action) => {
      let url = `${API_URL}/api/cardspress/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCardspress(response.data)),
        startWith(loadingCardspress()),
        catchError(() => of(loadingCardspressFailed()))
      )
    })
  )
}

const addCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspressActionTypes.ADD_CARDSPRESS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/cardspress/`, data, config)).pipe(
        map((response) => addedCardspress(response.data)),
        startWith(addingCardspress()),
        catchError((err) => of(addingCardspressFailed(err.response)))
      )
    })
  )

const removeCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspressActionTypes.REMOVE_CARDPRESS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardspress/${action.payload._id}`)).pipe(
        map((response) => removedCardpress()),
        startWith(removingCardpress()),
        catchError(() => of(removingCardpressFailed()))
      )
    )
  )

const softRemoveCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspressActionTypes.SOFT_REMOVE_CARDSPRESS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardspress/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCardspress(response.data.record)),
        startWith(softRemovingCardspress()),
        catchError((err) => of(softRemovingCardspressFailed(err.response)))
      )
    )
  )

const editCardspressEpic: Epic<CardspressAction, CardspressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspressActionTypes.EDIT_CARDSPRESS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/cardspress/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCardspress(response.data)),
        startWith(editingCardspress()),
        catchError((err) => of(editingCardspressFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCardspressEpic,
  loadCardspressEpic,
  addCardspressEpic,
  removeCardspressEpic,
  softRemoveCardspressEpic,
  editCardspressEpic
)
